import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import AssetsCard from "./components/AssetsCard";
import LiabilitiesCard from "./components/LiabilitiesCard";
import {isExpanded} from "../../utils";


const OtherAssetsSection = (props) => {
  const {
    data,
    openModal,
    expandedItems,
    onExpandedItemsChange,
    withOtherAssets,
    withLiabilities,
  } = props;

  const onAssetsExpand = React.useCallback((newState) =>
    onExpandedItemsChange('overviewTabSections.otherAssets', newState),
    [onExpandedItemsChange]
  );

  const onLiabilitiesExpand = React.useCallback((newState) =>
    onExpandedItemsChange('overviewTabSections.liabilities', newState),
    [onExpandedItemsChange]
  );

  return (
    <>
      {withOtherAssets && (
        <Grid item xs={12} md={withLiabilities ? 6 : 12} data-id={'otherAssets-container'}>
          <AssetsCard
            loading={data.loading}
            error={data.error}
            total={_.get(data, 'data.data.total.other_assets_value')}
            openModal={openModal}
            expanded={isExpanded(expandedItems, 'overviewTabSections.otherAssets')}
            onExpanded={onAssetsExpand}
          />
        </Grid>
      )}
      {withLiabilities && (
        <Grid item xs={12} md={withOtherAssets ? 6 : 12} data-id={'liabilities-container'}>
          <LiabilitiesCard
            loading={data.loading}
            error={data.error}
            total={_.get(data, 'data.data.total.liabilities_value')}
            openModal={openModal}
            expanded={isExpanded(expandedItems, 'overviewTabSections.liabilities')}
            onExpanded={onLiabilitiesExpand}
          />
        </Grid>
      )}
    </>
  )
};

export default OtherAssetsSection;